import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import axios from "axios";
import { Field, Form, Formik } from "formik";
import { Button, Col, Container, Row } from "react-bootstrap";
import { apiUtil } from "../../util";
import { FormInput, FormSelect } from "../forms/elements";
import { Loading } from "../state";
import FormCheckboxHtmlLabel from "../forms/elements/CheckboxHtmlLabel";
import moment from "moment";
import { accountDuck } from "../../ducks/account";
import { connect } from "react-redux";
import { loyaltyDuck } from "../../ducks/loyalty";
import { rewardsDuck } from "../../ducks/rewards";
import { AuthenticationState } from "react-aad-msal";
import { getSessionStorageKey } from "../../util/sessionStorage";
import { cartDuck } from '../../ducks/cart';
import { formStart, formComplete } from '../../util';
var accountOperations = accountDuck.operations;
var loyaltyOperations = loyaltyDuck.operations;
var rewardsOperations = rewardsDuck.operations;
var cartOperations = cartDuck.operations;

var formStartTracker = function formStartTracker() {
  formStart({
    identifier: 'LoyaltySignUpForm',
    name: 'Loyalty Registration'
  });
};

var formCompleteTracker = function formCompleteTracker() {
  formComplete({
    identifier: 'LoyaltySignUpForm',
    name: 'Loyalty Registration'
  });
};

var canRedirectToSweepstakes = function canRedirectToSweepstakes() {
  var isActiveSweepstake = window.sessionStorage.getItem("redirectToSweepstakeOnLogin");
  return isActiveSweepstake;
};

var redirectToSweepstakes = function redirectToSweepstakes() {
  window.sessionStorage.removeItem("redirectToSweepstakeOnLogin");
  window.location.href = "/sweepstakes";
};

var LoyaltySignUpForm = /*#__PURE__*/function (_Component) {
  _inherits(LoyaltySignUpForm, _Component);

  var _super = _createSuper(LoyaltySignUpForm);

  function LoyaltySignUpForm(props) {
    var _this;

    _classCallCheck(this, LoyaltySignUpForm);

    _this = _super.call(this, props);
    _this.defaultMonthOption = {
      value: "",
      label: props.labelBirthdayMonth
    };
    _this.defaultDayOption = {
      value: "",
      label: props.labelBirthdayDay
    };
    _this.state = {
      apiErrorMessage: null,
      legalFieldChecked: false,
      monthOptions: [_this.defaultMonthOption],
      dayOptions: [_this.defaultDayOption],
      showForm: false
    };
    return _this;
  }

  _createClass(LoyaltySignUpForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      formStartTracker();

      if (this.props.emailAddress && this.props.token) {
        var _this$props$handleGet;

        (_this$props$handleGet = this.props.handleGetUserInfo(this.props.emailAddress, apiUtil.API.loyalty.getAccountDetails, this.props.token)) === null || _this$props$handleGet === void 0 ? void 0 : _this$props$handleGet.then(function (response) {
          var asyncProcessResponse = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
              var _response$data;

              var _response$data2, _response$data3, _response$data4, _response$data5, _response$data6, _response$data7, _response$data8, _response$data9, _response$data10, _response$data11, _response$data12, newResponse, _response$data13, _response$data13$even, cookies;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.email)) {
                        _context.next = 29;
                        break;
                      }

                      newResponse = {
                        FirstName: ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.firstName) || "",
                        LastName: ((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.lastName) || "",
                        HomePhone: ((_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.mobilePhone) || ((_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.homePhone) || "",
                        ExternalCustomerId: ((_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.externalCustomerId) || "",
                        Balance: ((_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.balance) || 0,
                        EnrolledAt: ((_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.enrolledAt) || "",
                        Email: ((_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.email) || "",
                        Birthdate: ((_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.birthdate) || "",
                        Unsubscribed: ((_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.unsubscribed) ? true : false,
                        Status: ((_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.status) || ""
                      };
                      _context.prev = 2;
                      _context.next = 5;
                      return _this2.props.setLocalPegPoints(newResponse.Balance);

                    case 5:
                      _context.next = 7;
                      return _this2.props.setLoyaltyAccountData(newResponse);

                    case 7:
                      _context.next = 9;
                      return _this2.props.checkPersonalizationOverlays();

                    case 9:
                      _context.next = 11;
                      return _this2.props.setTransactionLimitInfo({
                        transactionLimitReached: ((_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : (_response$data13$even = _response$data13.eventSummary) === null || _response$data13$even === void 0 ? void 0 : _response$data13$even.transactionsAllowedToEarn) > 0 ? false : true
                      });

                    case 11:
                      _context.next = 13;
                      return _this2.props.checkTransactionLimit();

                    case 13:
                      _context.next = 15;
                      return _this2.props.resetRewardsRedemptionAction();

                    case 15:
                      _context.next = 17;
                      return _this2.props.postAccount(_this2.props.token);

                    case 17:
                      cookies = _this2.props.cookies;
                      cookies.set('scLoggedin', true, {
                        path: '/'
                      });
                      _context.next = 24;
                      break;

                    case 21:
                      _context.prev = 21;
                      _context.t0 = _context["catch"](2);
                      console.log('Error setting loyalty account data', _context.t0.message);

                    case 24:
                      _this2.props.setForceLogout(false);

                      window.sessionStorage.setItem("cbUserJustLoggedIn", "true");
                      setTimeout(function () {
                        if (canRedirectToSweepstakes() && !(response === null || response === void 0 ? void 0 : response.redirectUrl.includes("mobilepay"))) {
                          redirectToSweepstakes();
                        } else {
                          window.location.href = (response === null || response === void 0 ? void 0 : response.redirectUrl) || window.location.origin;
                        }
                      });
                      _context.next = 30;
                      break;

                    case 29:
                      _this2.setState({
                        showForm: true
                      });

                    case 30:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[2, 21]]);
            }));

            return function asyncProcessResponse(_x) {
              return _ref.apply(this, arguments);
            };
          }();

          setTimeout(function () {
            asyncProcessResponse(response);
          }, 1000);
        }).catch(function (e) {
          console.log("Error getting user info", e.message);
          window.location.href = window.location.origin;
        });
        this.generateMonths();
      } else {
        window.location.href = window.location.origin;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.onUnload);
    }
  }, {
    key: "generateMonths",
    value: function generateMonths() {
      var months = moment.months();
      months = months.map(function (m, i) {
        return {
          value: (i + 1).toString(),
          label: m
        };
      });
      months.unshift(this.defaultMonthOption);
      this.setState({
        monthOptions: months
      });
    }
  }, {
    key: "generateDays",
    value: function generateDays(month) {
      var _this3 = this;

      if (!month) {
        this.setState({
          dayOptions: [this.defaultDayOption]
        });
      } else {
        var _days = moment("2020-".concat(month), "YYYY-M").daysInMonth();

        var days = [];

        for (var i = 1; i <= _days; i++) {
          if (i === 1) {
            this.setState({
              dayOptions: [{
                value: i.toString(),
                label: i.toString()
              }]
            });
          }

          days.push({
            value: i.toString(),
            label: i.toString()
          });
        }

        setTimeout(function () {
          _this3.setState({
            dayOptions: days
          });
        });
      }
    }
  }, {
    key: "handleUpdateMonth",
    value: function handleUpdateMonth(newMonth) {
      this.generateDays(newMonth);
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _sessionState$aadResp;

      var sessionState = getSessionStorageKey("account");
      var token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp = sessionState.aadResponse) === null || _sessionState$aadResp === void 0 ? void 0 : _sessionState$aadResp.jwtIdToken;
      return token;
    }
  }, {
    key: "createCookie",
    value: function createCookie(cookieName, cookieValue, expirationDays) {
      var date = new Date();
      date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + date.toUTCString();
      document.cookie = cookieName + "=" + cookieValue + "; " + expires + "; path=/;";
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          emailAddress = _this$props.emailAddress,
          errorEmail = _this$props.errorEmail,
          labelEmail = _this$props.labelEmail,
          labelFirstName = _this$props.labelFirstName,
          errorFirstName = _this$props.errorFirstName,
          labelLastName = _this$props.labelLastName,
          errorLastName = _this$props.errorLastName,
          labelPhoneNumber = _this$props.labelPhoneNumber,
          errorPhoneNumber = _this$props.errorPhoneNumber,
          copyBirthday = _this$props.copyBirthday,
          labelBirthdayMonth = _this$props.labelBirthdayMonth,
          labelBirthdayDay = _this$props.labelBirthdayDay,
          copyLegal = _this$props.copyLegal,
          btnText = _this$props.btnText,
          errorSubmit = _this$props.errorSubmit;
      var _this$props2 = this.props,
          _this$props2$postUpse = _this$props2.postUpsertAccountSfmc,
          postUpsertAccountSfmc = _this$props2$postUpse === void 0 ? function () {} : _this$props2$postUpse,
          _this$props2$putUpser = _this$props2.putUpsertAccountSfmc,
          putUpsertAccountSfmc = _this$props2$putUpser === void 0 ? function () {} : _this$props2$putUpser,
          _this$props2$setLoyal = _this$props2.setLoyaltyAccountData,
          setLoyaltyAccountData = _this$props2$setLoyal === void 0 ? function () {} : _this$props2$setLoyal;
      return /*#__PURE__*/React.createElement(Container, {
        className: "loyalty--sign-up-form__container"
      }, /*#__PURE__*/React.createElement(Loading, {
        isLoading: !this.state.showForm
      }), this.state.showForm && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Formik, {
        initialValues: {
          email: emailAddress,
          first_name: "",
          last_name: "",
          phone_number: "",
          birthday_month: "",
          birthday_day: ""
        },
        validateOnMount: true,
        validate: function validate(values) {
          var errors = {};

          if (!values.email || !/^[A-Z0-9._-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
            errors.email = errorEmail;
          }

          if (!values.first_name) {
            errors.first_name = errorFirstName;
          }

          if (!values.last_name) {
            errors.last_name = errorLastName;
          }

          if (!values.phone_number || values.phone_number.replace(/\D/g, "").length !== 10) {
            errors.phone_number = errorPhoneNumber;
          }

          return errors;
        },
        onSubmit: function onSubmit(values, _ref2) {
          var setSubmitting = _ref2.setSubmitting;

          if (!_this4.state.legalFieldChecked) {
            setSubmitting(false);

            _this4.setState({
              apiErrorMessage: "Please agree to the terms of use and privacy policy"
            });

            return;
          }

          formCompleteTracker();

          _this4.setState({
            apiErrorMessage: null
          });

          var accountInfo = {
            firstName: values.first_name,
            lastName: values.last_name,
            email: values.email,
            mobilePhone: values.phone_number,
            channel: "web"
          };

          if (values.birthday_month && values.birthday_day) {
            var slicedMonth = ("0" + values.birthday_month).slice(-2);
            var slicedDay = ("0" + values.birthday_day).slice(-2);
            accountInfo = _objectSpread(_objectSpread({}, accountInfo), {}, {
              birthDate: "2020-".concat(slicedMonth, "-").concat(slicedDay)
            });
          }

          axios({
            method: "post",
            headers: _objectSpread(_objectSpread({}, apiUtil.setHeaders()), {}, {
              Authorization: "Bearer ".concat(_this4.getToken())
            }),
            data: accountInfo,
            url: apiUtil.API.loyalty.postAccountDetails
          }).then(function (res) {
            var _data$loyalty, _data$loyalty$custome;

            var data = (res === null || res === void 0 ? void 0 : res.data) || {};

            if (data === null || data === void 0 ? void 0 : (_data$loyalty = data.loyalty) === null || _data$loyalty === void 0 ? void 0 : (_data$loyalty$custome = _data$loyalty.customers) === null || _data$loyalty$custome === void 0 ? void 0 : _data$loyalty$custome.email) {
              var _data$loyalty2;

              var customers = (data === null || data === void 0 ? void 0 : (_data$loyalty2 = data.loyalty) === null || _data$loyalty2 === void 0 ? void 0 : _data$loyalty2.customers) || {};
              var newData = {
                FirstName: (customers === null || customers === void 0 ? void 0 : customers.firstName) || "",
                LastName: (customers === null || customers === void 0 ? void 0 : customers.lastName) || "",
                HomePhone: (customers === null || customers === void 0 ? void 0 : customers.mobilePhone) || (customers === null || customers === void 0 ? void 0 : customers.homePhone) || "",
                ExternalCustomerId: (customers === null || customers === void 0 ? void 0 : customers.externalCustomerId) || "",
                Balance: (customers === null || customers === void 0 ? void 0 : customers.balance) || 0,
                EnrolledAt: (customers === null || customers === void 0 ? void 0 : customers.enrolledAt) || "",
                Email: (customers === null || customers === void 0 ? void 0 : customers.email) || "",
                Birthdate: (customers === null || customers === void 0 ? void 0 : customers.birthdate) || "",
                Unsubscribed: (customers === null || customers === void 0 ? void 0 : customers.unsubscribed) ? true : false,
                Status: (customers === null || customers === void 0 ? void 0 : customers.status) || ""
              };
              setLoyaltyAccountData(newData);

              var sfmcAccountInfo = _objectSpread(_objectSpread({}, accountInfo), {}, {
                loyaltyCustomerID: customers === null || customers === void 0 ? void 0 : customers.externalCustomerId,
                loyaltyAccountStatus: customers === null || customers === void 0 ? void 0 : customers.status
              }); //request to sfmc to store account info


              putUpsertAccountSfmc(sfmcAccountInfo).then(function () {
                _this4.props.setForceLogout(false);

                _this4.createCookie("showOnboardingModal", "true", 365);

                window.sessionStorage.setItem("cbUserJustLoggedIn", "true");
                setTimeout(function () {
                  if (canRedirectToSweepstakes()) {
                    redirectToSweepstakes();
                  } else {
                    window.location.href = window.location.origin;
                  }
                });
              }).catch(function (err) {
                console.error(err === null || err === void 0 ? void 0 : err.message);
                window.location.href = window.location.origin;
              });
            } else {
              _this4.setState({
                apiErrorMessage: errorSubmit
              });
            }
          }).catch(function (err) {
            _this4.setState({
              apiErrorMessage: err === null || err === void 0 ? void 0 : err.message
            });
          }).finally(function () {
            setSubmitting(false);
          });
        }
      }, function (_ref3) {
        var isSubmitting = _ref3.isSubmitting,
            isValid = _ref3.isValid,
            setFieldValue = _ref3.setFieldValue;
        return /*#__PURE__*/React.createElement(Form, {
          className: "loyalty--sign-up-form"
        }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
          type: "email",
          name: "email",
          className: "cb-form__input--full",
          label: labelEmail,
          value: emailAddress,
          disabled: true,
          component: FormInput
        }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
          type: "text",
          name: "first_name",
          className: "cb-form__input--full",
          label: labelFirstName,
          component: FormInput
        }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
          type: "text",
          name: "last_name",
          className: "cb-form__input--full",
          label: labelLastName,
          component: FormInput
        }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
          type: "tel",
          name: "phone_number",
          className: "cb-form__input--full",
          label: labelPhoneNumber,
          component: FormInput
        }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          xs: "12"
        }, /*#__PURE__*/React.createElement("span", {
          className: "loyalty--sign-up-form__bd-copy"
        }, copyBirthday)), /*#__PURE__*/React.createElement(Col, {
          xs: "6",
          className: "loyalty--sign-up-form__col-month"
        }, /*#__PURE__*/React.createElement(Field, {
          type: "select",
          name: "birthday_month",
          label: labelBirthdayMonth,
          options: _this4.state.monthOptions,
          component: FormSelect,
          changeHandler: function changeHandler(e) {
            setFieldValue("birthday_day", e.target.value ? "1" : "");

            _this4.handleUpdateMonth(e.target.value);
          }
        })), /*#__PURE__*/React.createElement(Col, {
          xs: "6",
          className: "loyalty--sign-up-form__col-day"
        }, /*#__PURE__*/React.createElement(Field, {
          type: "select",
          name: "birthday_day",
          label: labelBirthdayDay,
          options: _this4.state.dayOptions,
          component: FormSelect
        }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
          type: "checkbox",
          name: "legal_field",
          id: "legal_field",
          checked: _this4.state.legalFieldChecked,
          label: copyLegal,
          component: FormCheckboxHtmlLabel,
          changeHandler: function changeHandler() {
            _this4.setState({
              legalFieldChecked: !_this4.state.legalFieldChecked
            });
          }
        }))), _this4.state.apiErrorMessage ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
          xs: "12"
        }, /*#__PURE__*/React.createElement("span", {
          className: "loyalty--sign-up-form__error"
        }, _this4.state.apiErrorMessage))) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
          type: "submit",
          disabled: isSubmitting || !isValid || !_this4.state.legalFieldChecked,
          className: "cb-button-primary loyalty--sign-up-form__submit"
        }, btnText), /*#__PURE__*/React.createElement(Loading, {
          isLoading: isSubmitting
        }))));
      }))));
    }
  }]);

  return LoyaltySignUpForm;
}(Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    postUpsertAccountSfmc: function postUpsertAccountSfmc(accountInfo) {
      return dispatch(accountOperations.postUpsertAccountSfmc(accountInfo));
    },
    putUpsertAccountSfmc: function putUpsertAccountSfmc(accountInfo) {
      return dispatch(accountOperations.putUpsertAccountSfmc(accountInfo));
    },
    setLoyaltyAccountData: function setLoyaltyAccountData(accountInfo) {
      return dispatch(loyaltyOperations.setLoyaltyAccountData(accountInfo));
    },
    getPegPoints: function getPegPoints(email) {
      return dispatch(rewardsOperations.handleGetPegPoints(email));
    },
    setLocalPegPoints: function setLocalPegPoints(points) {
      return dispatch(rewardsOperations.handleSetLocalPegPoints(points));
    },
    checkPersonalizationOverlays: function checkPersonalizationOverlays() {
      return dispatch(loyaltyOperations.handleCheckPersonalizationOverlays());
    },
    resetRewardsRedemptionAction: function resetRewardsRedemptionAction() {
      return dispatch(rewardsOperations.resetRewardsRedemptionAction());
    },
    applyRewards: function applyRewards(rewardsData) {
      return dispatch(cartOperations.handleApplyRewards(rewardsData));
    },
    checkTransactionLimit: function checkTransactionLimit() {
      return dispatch(loyaltyOperations.handleCheckTransactionLimit());
    },
    setTransactionLimitInfo: function setTransactionLimitInfo(info) {
      return dispatch(loyaltyOperations.setTransactionLimitInfo(info));
    },
    postAccount: function postAccount(token) {
      return dispatch(accountOperations.postAccount(token));
    }
  };
};

export default connect(null, mapDispatchToProps)(LoyaltySignUpForm);